import { DataTypeMimeModel, TypeMimeModel }
from '../models/academy/type-mime.model';
import { DataTypeResourceModel, TypeResourceModel }
from '../models/academy/type-resource.model';
import { Observable } from 'rxjs';
import {
  CategoryAcademyModel,
  DataCategoryAcademyModel,
} from '../models/academy/category-academy.model';
import { ContentAcademyModel, DataContentAcademyModel } from '../models/academy/content-academy.model';
import { ContentResourceModel, DataContentResourceModel } from '../models/academy/content-resource.model';

export abstract class AcademyRepository {
  abstract getCategoryAcademyAll(): Observable<CategoryAcademyModel>;
  abstract insertCategoryAcademy( params: DataCategoryAcademyModel): Observable<CategoryAcademyModel>;
  abstract updateCategoryAcademy( params: DataCategoryAcademyModel): Observable<CategoryAcademyModel>;

  abstract getAllContentAcademy(): Observable<ContentAcademyModel>;
  abstract insertContentAcademy( params: DataContentAcademyModel): Observable<ContentAcademyModel>;
  abstract updateContentAcademy(params: DataContentAcademyModel): Observable<ContentAcademyModel>;
  abstract getContentAcademyById(params: DataContentAcademyModel): Observable<ContentAcademyModel>;

  abstract insertContentResource(params: DataContentResourceModel ):Observable<ContentResourceModel>;
  abstract updateContentResource( params: DataContentResourceModel): Observable<ContentResourceModel>;
  abstract getContentResourceById(params: DataContentResourceModel): Observable<ContentResourceModel>;

  abstract getAllTypeResource(): Observable<TypeResourceModel>;
  abstract insertTypeResource(params:DataTypeResourceModel):Observable<TypeResourceModel>;
  abstract updateTypeResource(params:DataTypeResourceModel): Observable<TypeResourceModel>;
  
  abstract getAllTypeMime(): Observable<TypeMimeModel>;
  abstract insertTypeMime(params: DataTypeMimeModel):Observable<TypeMimeModel>;
  abstract updateTypeMime( params: DataTypeMimeModel):Observable<TypeMimeModel>;
}